import {v4 as uuidv4} from 'uuid';

export default function CreateGUID() {
    return uuidv4().replace(/-/g, '').toUpperCase();
}
